import { render } from "./Nephrology.vue?vue&type=template&id=ccdde69c&scoped=true"
import script from "./Nephrology.vue?vue&type=script&lang=ts"
export * from "./Nephrology.vue?vue&type=script&lang=ts"

import "./Nephrology.vue?vue&type=style&index=0&id=ccdde69c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ccdde69c"

export default script